var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInclude(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499999 0.25H8C8.15 0.25 8.25 0.35 8.25 0.5V3.75H11.5C11.65 3.75 11.75 3.85 11.75 4V11.5C11.75 11.65 11.65 11.75 11.5 11.75H4C3.85 11.75 3.75 11.65 3.75 11.5V8.25H0.499999C0.349998 8.25 0.249999 8.15 0.249999 8V0.5C0.249999 0.35 0.349998 0.25 0.499999 0.25ZM4.25 11.25H11.25V4.25H8.25V8C8.25 8.15 8.15 8.25 8 8.25H4.25V11.25ZM0.749999 7.75H3.75V4C3.75 3.85 3.85 3.75 4 3.75H7.75V0.75H0.749999V7.75Z",
    fill: "#797B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInclude);
export default __webpack_public_path__ + "static/media/include.3cb52fa6951b47bb75f120446e705ff8.svg";
export { ForwardRef as ReactComponent };